import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaTasks,
  FaMapMarkedAlt,
  FaUsers,
  FaRegCalendarAlt,
  FaMapMarkerAlt,
  FaCogs,
  FaCalendarAlt,
  FaUserCog,
  FaBoxOpen,
  FaTruck,
  FaDesktop,
  FaMobileAlt,
  FaChevronDown,
  FaChevronUp,
  FaSignOutAlt,
  FaPlusCircle,
  FaListAlt,

  FaListUl,           // Geo Tag List
  FaUserCheck,        // Available Deputy
  FaClipboardCheck,   // Allotment List
  FaHardHat,          // Duty Allotment (parent)
  FaTachometerAlt,    // Dashboard
  FaShapes,           // Event Type
  FaTools,            // Skills
  FaUserFriends,      // Deputy
  FaRegCalendarCheck, // Events
  FaMapSigns,         // Area
  FaClipboardList,    // Deputy's Skill
} from "react-icons/fa";



import {
  FaTachometerAlt,
  FaShapes,
  FaUserCog,
  FaUserFriends,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaClipboardCheck,
  FaMapMarkedAlt,
  FaPlusCircle,
  FaListUl,
  FaTasks,
  FaUserShield,
} from "react-icons/fa";




import { motion, AnimatePresence } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { admin, logout, updateToken } from "../ReduxStore/Slices/auth";
import { FaClipboardList, FaUserTie } from "react-icons/fa6";
// import logo from "../../assets/Logo/sarkarlogo.png"; // Adjust the path as necessary

// import logo from "../../assets/Logo/sarkarlogo.png"; // Adjust the path as necessary

// import logo from "../../assets/Footer/bhim.png";
// import logo from "../../assets/Logo/sarkarlogo.png"; // ✅ correct

// import logoObj from "../../../public/assets/Logo/sarkarlogo.png"

const Sidebar = ({ onLinkClick }) => {
    const logoUrl = "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Jharkhand_Rajakiya_Chihna.svg/300px-Jharkhand_Rajakiya_Chihna.svg.png";

  const Merchanttoken = useSelector((state) => state.auth.token);
  const userName = "Merchant";
  const adminLogo = "https://via.placeholder.com/150"; // Replace with actual logo URL

  const [openAccordion, setOpenAccordion] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const handleLogout = () => {
    dispatch(logout());

    navigate("/login");
  };

  // {`/admin/${Merchanttoken}/`}


const sidebarLinks = [
  {
    to: `/${Merchanttoken}/dashboard`,
    label: "Dashboard",
    icon: <FaTachometerAlt size={12} />,
    textClass: "text-[8px] sm:text-[10px] md:text=[12px] lg:text-[13px]",
  },
  {
    to: `/${Merchanttoken}/manageEventType`,
    label: "Manage Event Type",
    icon: <FaShapes size={12} />,
  },
  {
    to: `/${Merchanttoken}/manageSkills`,
    label: "Manage Skills",
    icon: <FaUserCog size={12} />,
    textClass: "text-[8px] sm:text-[10px] md:text=[12px] lg:text-[13px]",
  },
  {
    to: `/${Merchanttoken}/manageStaff`,
    label: "Manage Deputy",
    icon: <FaUserFriends size={12} />,
    textClass: "text-[8px] sm:text-[10px] md:text=[12px] lg:text-[13px]",
  },
  {
    to: `/${Merchanttoken}/manageEvent`,
    label: "Manage Event",
    icon: <FaCalendarAlt size={12} />,
    textClass: "text-[8px] sm:text-[10px] md:text=[12px] lg:text-[13px]",
  },
  {
    to: `/${Merchanttoken}/Updated-manageArea`,
    label: "Manage Area",
    icon: <FaMapMarkerAlt size={12} />,
    textClass: "text-[8px] sm:text-[10px] md:text=[12px] lg:text-[13px]",
  },
  {
    to: `/${Merchanttoken}/Staff-Skill`,
    label: "Deputy's Skill",
    icon: <FaClipboardCheck size={12} />,
    textClass: "text-[8px] sm:text-[10px] md:text=[12px] lg:text-[13px]",
  },
  {
    label: "Manage Geo Tag",
    icon: <FaMapMarkedAlt size={12} />,
    textClass: "text-[8px] sm:text-[10px] md:text=[12px] lg:text-[13px]",
    subLinks: [
      {
        to: `/${Merchanttoken}/geo-tag`,
        label: "Set Geo Tag Interval",
        icon: <FaPlusCircle size={10} />,
        textClass: "text-[6px] sm:text-[7px] md:text=[8px] lg:text-[11px]",
        textcolour: "text-gray-300",
      },
      {
        to: `/${Merchanttoken}/GeoTagList`,
        label: "Geo Tag List",
        icon: <FaListUl size={10} />,
        textClass: "text-[6px] sm:text-[7px] md:text=[8px] lg:text-[11px]",
        textcolour: "text-gray-300",
      },
      {
        to: `/${Merchanttoken}/deputy-location`,
        label: "Deputy Location",
        icon: <FaTasks size={10} />,
        textClass: "text-[6px] sm:text-[7px] md:text=[8px] lg:text-[11px]",
        textcolour: "text-gray-300",
      },
    ],
  },
  {
    label: "Duty Allotment",
    icon: <FaTasks size={12} />,
    textClass: "text-[8px] sm:text-[10px] md:text=[12px] lg:text-[13px]",
    to: `/${Merchanttoken}/Allotment`,
  },



  // **********************************************************


   {
    label: "Reserve Allotement",
    icon: <FaMapMarkedAlt size={12} />,
    textClass: "text-[8px] sm:text-[10px] md:text=[12px] lg:text-[13px]",
    subLinks: [
       {
    label: "Reserve Deputy",
    icon: <FaUserShield size={10} />,
       textClass: "text-[6px] sm:text-[7px] md:text=[8px] lg:text-[11px]",
    to: `/${Merchanttoken}/ReserveDeputy`,
  },
      {
        to: `/${Merchanttoken}/CheckpointList`,
        label: "Checkpoint List",
        icon: <FaListUl size={10} />,
        textClass: "text-[6px] sm:text-[7px] md:text=[8px] lg:text-[11px]",
        textcolour: "text-gray-300",
      },
        {
        to: `/${Merchanttoken}/reserveDeputyAllotement`,
        label: "Reserve Allotement",
        icon: <FaListUl size={10} />,
        textClass: "text-[6px] sm:text-[7px] md:text=[8px] lg:text-[11px]",
        textcolour: "text-gray-300",
      },
    ],
  },




];


  const renderLinks = (links, depth = 0) => {
    return (
      <ul className={`pl-${depth * 4} text-sm   `}>
        {links.map((link, index) => (
          <li key={index} className="mt-4">
            {link.subLinks ? (
              <>
                <button
                  onClick={() => toggleAccordion(index)}
                  className="hover:text-gray-400 w-full text-left flex items-center justify-between"
                >
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="flex items-center gap-3 "
                  >
                    {link.icon}
                    <span className="">{link.label}</span>
                  </motion.div>
                  {openAccordion === index ? (
                    <FaChevronUp className="size-2 ml-2" />
                  ) : (
                    <FaChevronDown className="size-2 ml-2" />
                  )}
                </button>
                <AnimatePresence initial={false}>
                  {openAccordion === index && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      {renderLinks(link.subLinks, depth + 1)}
                    </motion.div>
                  )}
                </AnimatePresence>
              </>
            ) : (
              <Link
                to={link.to}
                className={`hover:text-gray-400 flex items-center  ${
                  link.textClass || ""
                } ${link.textcolour}`}
                onClick={onLinkClick} // Close sidebar on link click
              >
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="flex items-center "
                >
                  {link.icon} <span className="ml-2">{link.label}</span>
                </motion.div>
              </Link>
            )}
          </li>
        ))}
      </ul>
    );
  };

  const handleprofileClick = () => {
    navigate(`/admin/${Merchanttoken}/profile`);
  };

  return (
    <div className="xl:fixed py-5 pr-12  xl:h-screen bg-slate-900 text-white  flex flex-col justify-between overflow-y-scroll scrollbar-hide">
      <div className="">

        <div className="  w-full items-start content-start  border-b  cursor-not-allowed border-b-red-700 ">

          <div className="flex gap-3 w-full   px-5  pb-3">
            <img
              className="w-8 h-8 "
              src={logoUrl}
              alt="logo"
            />

            <span className=" mt-1 font-bold text-gray-100">DMS Pakur</span>
          </div>

        </div>
        <nav className=" px-5 ">{renderLinks(sidebarLinks)}</nav>



      </div>
      <div className="mt-auto cursor-pointer mb-3 pl-3 ">
        <div
          className="hover:text-gray-400 flex items-center bg-green-600 px-4 py-1  my-auto rounded-md"
          onClick={handleLogout}
        >
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="flex items-center"
          >
            <FaSignOutAlt /> <span className="ml-2">Logout</span>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
